import type { TSummaryActionState } from './ExperienceSummary.types.ts';
import type { TSummaryActionStatus } from './summary-action/index.ts';

export const getSummaryActionStatus = ({
  isPending,
  isDone,
  error,
}: TSummaryActionState): TSummaryActionStatus => {
  if (isPending) {
    return 'pending';
  }

  if (isDone) {
    return 'done';
  }

  return error ? 'failed' : 'idle';
};
